import React from "react";
import "./footer-section.m.css";
import { WhatsappIcon } from "./whatsapp-icon";
import { MailIcon } from "./mail-icon";
import { SUBSCRIPTION_PAGE_STRINGS } from "../../../../constants";

const FooterSection = ({ colors = {} }) => {
  const s = SUBSCRIPTION_PAGE_STRINGS.DH, ph = "91 90352 67305", em = "support@deccanherald.com";
  const wa = `https://api.whatsapp.com/send/?phone=${ph.replace(/\s+/g, "")}&text=${encodeURIComponent("Hello, I need assistance with my Deccan Herald e-paper subscription. Could you please help me?")}&type=phone_number&app_absent=0`;
  const ml = `https://mail.google.com/mail/u/0/?fs=1&to=${em}&su=${encodeURIComponent("E-paper Support Request")}&body=${encodeURIComponent("Hello, I need assistance with my Deccan Herald e-paper subscription. Could you please help me?")}&tf=cm`;
  const st = colors.text_color ? { color: colors.text_color } : {};

  return (
    <section styleName="footer-section" style={{ backgroundColor: colors.palette3 }}>
      <div styleName="footer-box">
        <h3 styleName="footer-title" style={st}>{s.FOOTER_CONTACT_TITLE}</h3>
        <div styleName="contact-row">
          <a href={wa} target="_blank" rel="noopener noreferrer" styleName="contact-button" style={st}><WhatsappIcon /><span>{ph}</span></a>
          <a href={ml} target="_blank" rel="noopener noreferrer" styleName="contact-button" style={st}><MailIcon color="#999999" /><span style={{ marginLeft: 6 }}>{em}</span></a>
        </div>
        <div styleName="working-hours">
          <div styleName="working-hours-label" style={st}>{s.WORKING_HOURS_LABEL}</div>
          <div styleName="working-hours-time" style={st}>Mon - Fri : 10:00 AM to 6:00 PM</div>
        </div>
      </div>
    </section>
  );
};
export { FooterSection };
